import { PeopleDemo, TemplatesDemo } from '../conversations/PeopleTemplatesDemo';
import { Code } from './Section';
export function PeopleTemplatesTiles() {
  return (
    <>
      <div data-slot="people-pattern-tile" className="overflow-hidden rounded-lg border border-line bg-card">
        <div className="p-5">
          <PeopleDemo />
        </div>
        <p className="border-t border-line p-4">
          <Code>PersonPeek · PersonSummary · PersonProperties · ChannelPerson</Code>
        </p>
      </div>
      <div
        data-slot="templates-pattern-tile"
        className="overflow-hidden rounded-lg border border-line bg-card"
      >
        <div className="p-5">
          <TemplatesDemo />
        </div>
        <p className="border-t border-line p-4">
          <Code>ReplyTemplates · ReplyComposer · ReplyPreview</Code>
        </p>
      </div>
    </>
  );
}
